// Saving over the open scenario asks first (TX-US-0026): everyone who loads it sees the new figures.
// A refusal stays in the dialog beside the button that was refused.

import { useState } from 'react';

import { saveOverScenario } from '../api.js';
import Modal from '../ui/Modal.jsx';

export default function SaveOverDialog({ modelId, scenario, values, onClose, onSaved }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSaved(await saveOverScenario(modelId, scenario.scenario_id, values));
    } catch (err) {
      setError(err.fields ? Object.values(err.fields).join(' ') : err.message);
      setBusy(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <form onSubmit={onSubmit}>
        <h3>Save over “{scenario.name}”?</h3>
        <p className="hint">
          The figures on screen replace the saved ones, for everyone who loads this scenario.
        </p>
        {error && <p className="error">{error}</p>}
        <menu>
          <button type="button" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" disabled={busy}>{busy ? 'Saving…' : 'Save'}</button>
        </menu>
      </form>
    </Modal>
  );
}
